import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { getConfig } from './services/configService';

// Theme + CssBaseline are provided by CustomThemeProvider inside App.jsx
// (see contexts/ThemeContext.jsx). No second provider here.

const root = ReactDOM.createRoot(document.getElementById('root'));

// Load configuration before rendering the app
getConfig()
  .then(() => {
    root.render(
      <React.StrictMode>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error('❌ Failed to load configuration:', error);
    // Render error message
    root.render(
      <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
        <h1>Configuration Error</h1>
        <p>Failed to load application configuration.</p>
        <p style={{ color: 'red' }}>{error.message}</p>
        <p>Please ensure the application is properly deployed and try refreshing the page.</p>
      </div>
    );
  });